import React from "react";
import { Users, Scale, Lightbulb } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const coreValues = [{
  id: 1,
  title: "In-Home Comfort",
  description: "• Familiar surroundings for senior dogs • Reduced stress and travel anxiety • Full clinical toolkit brought to you • Personalized sessions in your living room.",
  iconName: "Users"
}, {
  id: 2,
  title: "Shared Clinical Space",
  description: "• Focused professional environment • Advanced mobility equipment • Athletic conditioning support • Specialized recovery protocols for active dogs.",
  iconName: "Scale"
}, {
  id: 3,
  title: "Athletic Performance",
  description: "• Post-hike recovery sessions • Trail-side mobility maintenance • Performance support for mountain dogs • Targeted injury prevention strategies.",
  iconName: "Lightbulb"
}];
export default function OurPrinciplesAndValues() {
  const renderIcon = (name: string) => {
    switch (name) {
      case "Users":
        return <Users className="w-8 h-8 text-secondary" />;
      case "Scale":
        return <Scale className="w-8 h-8 text-secondary" />;
      case "Lightbulb":
        return <Lightbulb className="w-8 h-8 text-secondary" />;
      default:
        return null;
    }
  };
  return <section data-section-id="224438" id="clinical-excellence-home-comfort" className="bg-background text-foreground py-24" dir="ltr">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground tracking-tight">
            Clinical Excellence & Home Comfort
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-20">
          {coreValues.map((value, i) => <div data-index={i} key={value.id} className="flex">
              <Card className="w-full border border-muted hover:border-secondary transition-colors duration-300 bg-card shadow-md hover:shadow-lg flex flex-col items-center text-center pt-8 pb-4 px-4 rounded-sm">
                <CardHeader className="pb-4 flex flex-col items-center">
                  <div className="w-16 h-16 rounded-full bg-accent flex items-center justify-center mb-6">
                    {renderIcon(value.iconName)}
                  </div>
                  <CardTitle className="font-default text-2xl text-foreground">
                    {value.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-default text-base text-muted-foreground leading-relaxed">
                    {value.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}